/**
 * @typedef {Object} ProviderOrderRecipientOwner
 * @property {number} [owner]
 */

/**
 * @typedef {Object} ProviderOrderDeliverySource
 * @property {number|string|null} [recipient]
 * @property {ProviderOrderRecipientOwner|null} [recipient_data]
 */

/**
 * True when `recipient` is a customer owned by the current entity (dropship).
 *
 * Connected supplier purchase orders persist the seller-owned
 * "buyer as customer" on `recipient`. That record must not be loaded via
 * `/api/customers/:id/deliverysites/` (it 404s for the buyer).
 *
 * @param {ProviderOrderDeliverySource|null|undefined} providerorder
 * @param {number|string|null|undefined} currentEntityId
 * @returns {boolean}
 */
export function isOwnProviderOrderRecipient(providerorder, currentEntityId) {
    if (!providerorder || providerorder.recipient == null || currentEntityId == null) {
        return false;
    }
    return providerorder.recipient_data?.owner == currentEntityId;
}
